import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { isBrowser, isMobile } from 'react-device-detect';
import React from 'react';

const MainBodyLayout = ({
  children = null,
  withBack = false,
  onPrevClick = null,
  title = null,
  className = '',
}) => {
  const history = useHistory();

  const closeCardSettings = () => history.push('/dashboard/card');

  return (
    <div
      style={{
        ...(isBrowser
          ? { flex: 1, overflowY: 'auto', paddingBottom: '9rem' }
          : { paddingBottom: '100px' }),
      }}
      className={`d-flex flex-column main-layout-body-container ${className} ${
        isBrowser ? 'hide-scroll' : ''
      }`}>
      <div className="d-flex flex-row justify-content-between align-items-center">
        {withBack && (
          <div
            className="cursor-pointer text-hover"
            onClick={onPrevClick}
            onKeyDown={onPrevClick}
            role="presentation">
            <i className="icon icon-arrow_back-navigation text-f5 me-2" aria-label="Back" />
          </div>
        )}
        <div className="d-flex flex-row align-items-center ">
          {isMobile && (
            <div
              onClick={closeCardSettings}
              onKeyDown={closeCardSettings}
              role="button"
              tabIndex={-1}>
              <i
                className="close-btn cursor-pointer icon icon-close-other text-dark text-f4 ms-2"
                aria-label="Close"
              />
            </div>
          )}
        </div>
      </div>
      <div
        className={`d-flex flex-row justify-content-start align-items-center ${
          isBrowser ? 'mt-4' : 'mt-3'
        }`}>
        <p className={`text-dark ${isBrowser ? 'text-f3' : 'text-f4'}`}>{title}</p>
      </div>
      {children}
    </div>
  );
};

export default MainBodyLayout;

MainBodyLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  withBack: PropTypes.bool,
  title: PropTypes.string,
  className: PropTypes.string,
  onPrevClick: PropTypes.func,
};
